export default __webpack_public_path__ + "static/media/logo.3cf4acc2.png";